import React, { useState, useEffect } from "react";
import AllWords from "../wordhunt/AllWords";
import axios from "axios";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

function AnagramsSolver() {
  const [letters, setLetters] = useState("");
  const [solutions, setSolutions] = useState([]);


  const url = "https://gamepigeon.pythonanywhere.com";
  const onSubmit = () => {
    if (letters != "") {
      axios
        .post(`${url}/anagrams`, {
          letters: letters,
        })
        .then(
          (response) => {
            setSolutions(response.data.validWords);
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }

  return (
      <div>
        <Form.Group as={Row} className="mb-3 justify-content-md-center">
            <Col xs="6" className="mb-3 w-75">
                <Form.Control 
                    type="text" 
                    placeholder="Enter all letters together (like asdfgh)" 
                    defaultValue={letters}
                    onChange={e => setLetters(e.target.value)}
                    />
            </Col>

            <Col xs="12" className="text-center">
                <Button variant="primary" onClick={onSubmit}>
                    Submit
                </Button>
            </Col>
        </Form.Group>
        <div className="mt-3">
          <AllWords words={solutions} normal={true}/>
        </div>
      </div>
  );
}

export default AnagramsSolver;
